var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBooking = function SvgBooking(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00016,
    y: 2.80029,
    width: 18,
    height: 16.2,
    rx: 1.35,
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95016 1V4.6",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0501 1V4.6",
    stroke: "#8390A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 10.9002C10.7458 10.9002 11.3502 10.2958 11.3502 9.5502C11.3502 8.80461 10.7458 8.2002 10.0002 8.2002C9.2546 8.2002 8.65019 8.80461 8.65019 9.5502C8.65019 10.2958 9.2546 10.9002 10.0002 10.9002Z",
    fill: "#8390A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9501 10.9002C15.6957 10.9002 16.3001 10.2958 16.3001 9.5502C16.3001 8.80461 15.6957 8.2002 14.9501 8.2002C14.2046 8.2002 13.6001 8.80461 13.6001 9.5502C13.6001 10.2958 14.2046 10.9002 14.9501 10.9002Z",
    fill: "#8390A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05012 15.8499C5.7957 15.8499 6.40012 15.2455 6.40012 14.4999C6.40012 13.7543 5.7957 13.1499 5.05012 13.1499C4.30453 13.1499 3.70012 13.7543 3.70012 14.4999C3.70012 15.2455 4.30453 15.8499 5.05012 15.8499Z",
    fill: "#8390A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 15.8499C10.7458 15.8499 11.3502 15.2455 11.3502 14.4999C11.3502 13.7543 10.7458 13.1499 10.0002 13.1499C9.2546 13.1499 8.65019 13.7543 8.65019 14.4999C8.65019 15.2455 9.2546 15.8499 10.0002 15.8499Z",
    fill: "#8390A1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBooking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booking.ec73cb92.svg";
export { ForwardRef as ReactComponent };